export const APP_DILIGENCE_URL = process.env.REACT_APP_DILIGENCE_URL;
export const BASE_URL = `${process.env.REACT_APP_DILIGENCE_TEST_URL}`;
export const BASE_API_URL = `${process.env.REACT_APP_DILIGENCE_URL}/api`;
export const API_USER_URL = `${BASE_API_URL}/users`;
export const API_TFA_URL = `${BASE_API_URL}/two_factor_auth`;
export const API_REQUEST_URL = `${BASE_API_URL}/requests`;
export const API_USER_FILTERS_URL = `${API_USER_URL}/current/filters`;
